import { MouseEvent } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@mui/icons-material';
import { IconButton } from '@components/atoms/Button';

type TablePaginationActionsProps = {
  count: number;
  onPageChange: (event: MouseEvent<HTMLButtonElement>, newPage: number) => void;
  page: number;
  rowsPerPage: number;
};

export const TablePaginationActions = (props: TablePaginationActionsProps) => {
  const theme = useTheme();

  const { count, onPageChange, page, rowsPerPage } = props;

  const handleFirstPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
        variant="text"
      >
        {theme.direction === 'rtl' ? (
          <LastPage />
        ) : (
          <FirstPage sx={page > 0 ? { color: theme.palette.action.active } : {}} />
        )}
      </IconButton>

      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
        variant="text"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft sx={page > 0 ? { color: theme.palette.action.active } : {}} />
        )}
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
        variant="text"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight
            sx={
              page >= Math.ceil(count / rowsPerPage) - 1
                ? { color: theme.palette.action.disabled }
                : { color: theme.palette.action.active }
            }
          />
        )}
      </IconButton>

      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
        variant="text"
      >
        {theme.direction === 'rtl' ? (
          <FirstPage />
        ) : (
          <LastPage
            sx={
              page >= Math.ceil(count / rowsPerPage) - 1
                ? { color: theme.palette.action.disabled }
                : { color: theme.palette.action.active }
            }
          />
        )}
      </IconButton>
    </Box>
  );
};
